import useApi from '../../api';

const DownloadCell = ({value, url}) => {
    const { downloadFile } = useApi()

    const onClick = async () => {
        const response = await downloadFile(url);

        if (!response.data?.downloadLocation) {
            console.warn('Missing downloadLocation');
        }

        window.open(response.data.downloadLocation)
    }

    return (
        <button onClick={onClick}>{value }</button>
    )
}

export default DownloadCell;